module.exports = __webpack_public_path__ + "assets/img/056f1f955f0ea50fff77562474980af4.png";